import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '@/logic/break/BreakUtils';

registerCollisionAnimation('PIXEL_CRUMBLE', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const particles = config.collisionEffectParticleCount || 20;
  const gravity = config.collisionEffectGravity || 0.5;
  const size = 8;
  for (let i = 0; i < particles; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = rnd * Math.PI * 2;
    const dist = 20 + progress * 50;
    const t = elapsed / 16.6;
    const x = e.pos.x + Math.cos(angle) * dist;
    const y = e.pos.y + Math.sin(angle) * dist + 0.5 * gravity * t * t;

    ctx.fillStyle = determineColor(i, particles);
    ctx.globalAlpha = 1 - progress;
    ctx.fillRect(x - size / 2, y - size / 2, size, size);
  }
});
